import BookAppointmentButton from '../store-calendar/BookAppointmentButton';
import React from 'react';
import { Button } from 'react-bootstrap';
import CustomerNameEdit from '../common/CustomerNameEdit';

export default function PipelineRecordControls({ record, loading, onDetails, onFiles, onWorksheet, onNameSaved, entity = 'contact' }) {
  const name = [record?.buyer,record?.coBuyer].filter(Boolean).join(', ');
  return <div className="pipeline-record-controls" aria-label="Selected record controls">
    <strong className="pipeline-record-name" title={name}>{name || 'Select a customer'}{!loading && onNameSaved && <CustomerNameEdit record={record} entity={entity} onSaved={onNameSaved}/>}</strong>
    {record && !loading && <div className="pipeline-record-actions">
      {entity === 'contact' && record._id && <BookAppointmentButton contactId={record._id} size="sm" />}
      {onDetails && <Button size="sm" variant="outline-primary" onClick={onDetails}>Customer details</Button>}
      {onFiles && <Button size="sm" variant="outline-primary" onClick={onFiles}>Files</Button>}
      {onWorksheet && <Button size="sm" variant="outline-primary" onClick={onWorksheet}>Worksheet</Button>}
    </div>}
  </div>;
}
